export default "__VITE_ASSET__DzCxhLjl__"